import { context, type Span, trace } from '@opentelemetry/api';
import { apiGet } from '@/api/apiClient';
import type { Ship } from '@/api/ships/types';
import { instrumentAsync } from '@/otel';

export async function getShips(): Promise<Ship[]> {
  return instrumentAsync('api.ships.getShips', async (span: Span) => {
    const res = await apiGet<Ship[]>(
      '/ships',
      trace.setSpan(context.active(), span),
    );

    return res.data;
  });
}
